import COUNTRIES from '../countries.translations'

import translations from './titanium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/titanium'

export const titanium: Metal = {
  id: 34,
  slug: 'titanium',
  name: t.name,
  symbol: 'Ti',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Panzhihua, titanium mine (China)',
      region: t.mine0Region,
      slug: 'panzhihua',
      coordinates: [101.72, 26.58],
    },
    {
      name: 'Moma, titanium mine (Mozambique)',
      region: t.mine1Region,
      slug: 'moma',
      coordinates: [39.64, -16.53],
    },
    {
      name: 'Richards Bay, titanium mine (South Africa)',
      region: t.mine2Region,
      slug: 'richards-bay',
      coordinates: [32.05, -28.78],
    },
    {
      name: 'Sokndal, titanium mine (Norway)',
      region: t.mine3Region,
      slug: 'sokndal',
      coordinates: [6.27, 58.34],
    },
    {
      name: 'Mombasa, titanium mine (Kenya)',
      region: t.mine4Region,
      slug: 'mombasa',
      coordinates: [39.67, -4.05],
    },
    {
      name: 'Havre-Saint-Pierre, titanium mine (Canada)',
      region: t.mine5Region,
      slug: 'havre-saint-pierre',
      coordinates: [-63.6, 50.24],
    },
  ],
  countries: [
    { name: COUNTRIES.china, percent: 35 },
    { name: COUNTRIES.mozambique, percent: 20 },
    { name: COUNTRIES.southAfrica, percent: 15 },
    { name: COUNTRIES.australia, percent: 6 },
    { name: COUNTRIES.norway, percent: 4 },
    { name: COUNTRIES.canada, percent: 4 },
  ],
  // Vanadium is alloyed into the titanium premium phone frames use.
  related: ['vanadium'],
  content: {
    smartphone: {
      quantityScore: 2,
      quantityLabel: t.smartphone.label,
      parts: ['electronics', 'camera', 'casing'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 2, ...t.supplyRisk },
    recycling: { score: 2, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
          credit: 'Bloomberg / Getty',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
